module.exports = __webpack_public_path__ + "img/swImg-err.2e666ea3.png";